import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=270baf93&scoped=true"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"
import style0 from "./addRole.vue?vue&type=style&index=0&id=270baf93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270baf93",
  null
  
)

export default component.exports